import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function Hero() {
  return <section className="relative h-screen w-full overflow-hidden flex flex-col md:flex-row" data-id="element-66">
      {/* Left Side: The Taste */}
      <div className="relative w-full h-1/2 md:h-full md:w-1/2 overflow-hidden group" data-id="element-67">
        <motion.div initial={{
        scale: 1.1,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 1.5,
        ease: 'easeOut'
      }} className="absolute inset-0" data-id="element-68">
          <video src="https://cdn.magicpatterns.com/uploads/cpQt9oFY3prgn9bqWP7TKz/6645805-hd_720_1280_30fps.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover grayscale-[20%] brightness-75 transition-transform duration-[3000ms] group-hover:scale-110" data-id="element-69" />
          {/* Amber Light Leak Overlay */}
          <div className="absolute inset-0 bg-gradient-to-tr from-crimson/10 via-champagne/10 to-transparent mix-blend-screen" data-id="element-70" />
          <div className="absolute inset-0 bg-obsidian/40" data-id="element-71" />
        </motion.div>

        {/* Desktop Left Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1,
        duration: 1
      }} className="hidden md:block absolute bottom-12 left-12 z-20 w-max" data-id="element-72">
          <motion.div whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} data-id="element-73">
            <Link to="/eat" className="inline-block px-8 py-3 border-2 border-champagne text-sm tracking-[0.3em] text-champagne font-bold uppercase font-sans hover:bg-champagne hover:text-obsidian transition-all duration-500 backdrop-blur-sm shadow-[0_0_15px_rgba(197,160,89,0.3)]" data-id="element-74">
              Discover the Taste
            </Link>
          </motion.div>
        </motion.div>
      </div>

      {/* Right Side: The Night */}
      <div className="relative w-full h-1/2 md:h-full md:w-1/2 overflow-hidden group" data-id="element-75">
        <motion.div initial={{
        scale: 1.1,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 1.5,
        ease: 'easeOut',
        delay: 0.2
      }} className="absolute inset-0" data-id="element-76">
          <video src="https://cdn.magicpatterns.com/uploads/bpPR7fS7CbadaaE1Hs1gsX/20436209-hd_720_1280_60fps.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover brightness-50 contrast-125 transition-transform duration-[3000ms] group-hover:scale-110" data-id="element-77" />
          {/* Red Neon Glow Overlay */}
          <div className="absolute inset-0 bg-crimson/20 mix-blend-overlay" data-id="element-78" />
          <div className="absolute inset-0 bg-obsidian/40" data-id="element-79" />
        </motion.div>

        {/* Desktop Right Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1.2,
        duration: 1
      }} className="hidden md:block absolute bottom-12 right-12 z-20 w-max" data-id="element-80">
          <motion.div whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} data-id="element-81">
            <Link to="/nightlife" className="inline-block px-8 py-3 border-2 border-champagne text-sm tracking-[0.3em] text-champagne font-bold uppercase font-sans hover:bg-champagne hover:text-obsidian transition-all duration-500 backdrop-blur-sm shadow-[0_0_15px_rgba(197,160,89,0.3)]" data-id="element-82">
              Experience the Night
            </Link>
          </motion.div>
        </motion.div>
      </div>

      {/* Mobile Side-by-Side Buttons */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 1.2,
      duration: 1
    }} className="absolute bottom-8 left-0 right-0 z-40 flex md:hidden justify-center gap-4 px-4" data-id="element-83">
        <motion.div whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="flex-1 flex" data-id="element-84">
          <Link to="/eat" className="w-full px-2 py-3 border-2 border-champagne text-[8px] tracking-[0.2em] text-champagne font-bold uppercase font-sans hover:bg-champagne hover:text-obsidian transition-all duration-500 backdrop-blur-sm shadow-[0_0_15px_rgba(197,160,89,0.3)] text-center" data-id="element-85">
            Discover the Taste
          </Link>
        </motion.div>
        <motion.div whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="flex-1 flex" data-id="element-86">
          <Link to="/nightlife" className="w-full px-2 py-3 border-2 border-champagne text-[8px] tracking-[0.2em] text-champagne font-bold uppercase font-sans hover:bg-champagne hover:text-obsidian transition-all duration-500 backdrop-blur-sm shadow-[0_0_15px_rgba(197,160,89,0.3)] text-center" data-id="element-87">
            Experience the Night
          </Link>
        </motion.div>
      </motion.div>

      {/* Center Ghost Box Overlay */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-30 px-4" data-id="element-88">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.5,
        duration: 1.2,
        ease: 'easeOut'
      }} className="relative px-8 py-2 md:px-20 md:py-4 border border-crimson/40 backdrop-blur-md bg-obsidian/40 w-full max-w-[320px] md:max-w-none shadow-[0_0_30px_rgba(219,32,39,0.15)]" data-id="element-89">
          {/* Decorative Corners */}
          <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-champagne" data-id="element-90" />
          <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-champagne" data-id="element-91" />
          <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-champagne" data-id="element-92" />
          <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-champagne" data-id="element-93" />

          <div className="text-center" data-id="element-94">
            <h1 className="text-4xl md:text-8xl font-serif text-champagne tracking-tighter leading-none mb-1 drop-shadow-[0_2px_10px_rgba(197,160,89,0.3)]" data-id="element-95">
              RED LOUNGE
            </h1>
            <div className="w-full h-[2px] bg-gradient-to-r from-transparent via-crimson to-transparent mx-auto mb-1 opacity-90" data-id="element-96" />
            <p className="text-[10px] md:text-xs uppercase tracking-[0.4em] md:tracking-[0.6em] text-white/90 font-sans" data-id="element-97">
              A Legendary DC Institution
            </p>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 2,
      duration: 1
    }} className="absolute bottom-6 left-1/2 -translate-x-1/2 z-40 hidden md:block" data-id="element-98">
        <div className="flex flex-col items-center gap-2" data-id="element-99">
          <span className="text-[10px] uppercase tracking-[0.3em] text-white/50 font-sans" data-id="element-100">
            Scroll
          </span>
          <div className="w-[1px] h-12 bg-gradient-to-b from-champagne/40 to-transparent" data-id="element-101" />
        </div>
      </motion.div>
    </section>;
}